var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYahoo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#720E9E",
    d: "M11.972 0c6.612 0 11.972 5.36 11.972 11.972 0 6.612-5.36 11.972-11.972 11.972C5.36 23.944 0 18.584 0 11.972 0 5.36 5.36 0 11.972 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.454 9.45l.012-.002.397-.441-.02-.002.042-.066H12.33l.214.76h1.516l-2.552 2.361c-.52-.76-1.741-2.505-2.593-3.814h1.583v-.539l.022-.155-.022-.003v-.063H4.49v.76H6.37c.73.602 3.892 4.442 4.008 4.809.046.343.112 2.37-.024 2.523-.164.236-1.875.108-2.177.13l-.011.745c.55.017 2.203 0 2.76 0 1.099 0 3.022-.029 3.293-.007l.034-.705-2.211-.033c-.047-.32-.097-2.336-.051-2.556.209-.638 3.601-3.28 3.95-3.38l.329-.073h1.025l.16-.249zm-.83 5.269l.961.073 1.12-4.108c-.187-.006-1.886-.158-2.107-.2l.027 4.235zm-.166.658l.006 1.004.486.04.525.037.154-.982-.553-.025-.618-.074z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahoo);
export default __webpack_public_path__ + "static/media/yahoo.6b24fcc2.svg";
export { ForwardRef as ReactComponent };